"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormTextarea = void 0;
var React = __importStar(require("react"));
var FormLabel_1 = require("./FormLabel");
var FormTextarea = /** @class */ (function (_super) {
    __extends(FormTextarea, _super);
    function FormTextarea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormTextarea.prototype.render = function () {
        var _a = this.props, name = _a.name, placeholder = _a.placeholder, label = _a.label, errorMessage = _a.errorMessage, hint = _a.hint, onChange = _a.onChange, value = _a.value, hasError = _a.hasError, required = _a.required, maxLength = _a.maxLength, id = _a.id;
        return (React.createElement("div", { className: "textarea-wrapper" },
            React.createElement("div", { className: "form-label-wrapper" }, !!label &&
                React.createElement(FormLabel_1.FormLabel, { title: label, required: required, hint: hint })),
            React.createElement("div", { className: "form-input-wrapper clearfix" + (hasError ? " form-error" : "") },
                React.createElement("textarea", { id: id ? id : undefined, className: "df-textarea", placeholder: placeholder, name: name, onChange: onChange, value: value, maxLength: maxLength }),
                React.createElement("span", { className: "form-message__error" },
                    errorMessage,
                    "\u00A0"))));
    };
    return FormTextarea;
}(React.Component));
exports.FormTextarea = FormTextarea;
